module.exports = __webpack_public_path__ + "static/longheading-29c8fa5ec4466c73c659403bd374ef90.png";